import { createFileRoute, redirect } from '@tanstack/react-router'
import { hasGrant } from '@/lib/me'

/**
 * Legacy URL. The workspace now lives under the owning bank account, and this
 * route has no bank account ID to build that path with, so it drops the
 * reconciliation ID and returns the user to the bank account list.
 */
export const Route = createFileRoute('/_authenticated/accounting/reconcile/$reconciliationId')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_reconciliation.view')) {
      throw redirect({ to: '/accounting' })
    }

    throw redirect({ to: '/accounting/bank-accounts' })
  },
})
